export const SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION_POSITION = {
  men: {
    fields: [
      "selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_men",
      "selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_men",
      "selfAssessment_laborConditions_genderDiscrimination_position_peers_men",
      "selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_men",
    ],
    total:
      "selfAssessment_laborConditions_genderDiscrimination_position_total_men",
  },
  women: {
    fields: [
      "selfAssessment_laborConditions_genderDiscrimination_position_subordinateOf_women",
      "selfAssessment_laborConditions_genderDiscrimination_position_superiorOf_women",
      "selfAssessment_laborConditions_genderDiscrimination_position_peers_women",
      "selfAssessment_laborConditions_genderDiscrimination_position_otherHierarchical_women",
    ],
    total:
      "selfAssessment_laborConditions_genderDiscrimination_position_total_women",
  },
};

export const SELF_ASSESSMENT_LABOR_CONDITIONS_SEXUAL_HARASSMENT_RECEIVED = {
  women: {
    received: {
      fields: [
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_women",
      ],
      total:
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_women",
      superTotal:
        "selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_women",
    },
    resolved: {
      fields: [
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_women",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_women",
      ],
      total:
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_women",
      superTotal:
        "selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_women",
    },
  },
  men: {
    received: {
      fields: [
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_received_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_received_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_received_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_received_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_received_men",
      ],
      total:
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_received_men",
      superTotal:
        "selfAssessment_laborConditions_preventingSexualHarassment_complaintsReceived_men",
    },
    resolved: {
      fields: [
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_recruitment_resolved_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_promotion_resolved_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesCompany_resolved_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_responsibilitiesChain_resolved_men",
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_other_resolved_men",
      ],
      total:
        "selfAssessment_laborConditions_sexualHarassment_receivedResolved_total_resolved_men",
      superTotal:
        "selfAssessment_laborConditions_preventingSexualHarassment_complaintsAddressed_men",
    },
  },
};

export const SELF_ASSESSMENT_LABOR_CONDITIONS_POSITION = {
  men: {
    fields: [
      "selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_men",
      "selfAssessment_laborConditions_sexualHarassment_position_superiorOf_men",
      "selfAssessment_laborConditions_sexualHarassment_position_peers_men",
      "selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_men",
    ],
    total: "selfAssessment_laborConditions_sexualHarassment_position_total_men",
  },
  women: {
    fields: [
      "selfAssessment_laborConditions_sexualHarassment_position_subordinateOf_women",
      "selfAssessment_laborConditions_sexualHarassment_position_superiorOf_women",
      "selfAssessment_laborConditions_sexualHarassment_position_peers_women",
      "selfAssessment_laborConditions_sexualHarassment_position_otherHierarchical_women",
    ],
    total:
      "selfAssessment_laborConditions_sexualHarassment_position_total_women",
  },
};

export const SELF_ASSESSMENT_LABOR_CONDITIONS_GENDER_DISCRIMINATION = {
  men: {
    received: {
      fields: [
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_men",
      ],
      total:
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_men",
    },
    resolved: {
      fields: [
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_men",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_men",
      ],
      total:
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_men",
    },
  },
  women: {
    received: {
      fields: [
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_received_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_received_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_received_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_received_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_received_women",
      ],
      total:
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_received_women"
    },
    resolved: {
      fields: [
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_recruitment_resolved_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_promotion_resolved_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesCompany_resolved_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_responsibilitiesChain_resolved_women",
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_other_resolved_women",
      ],
      total:
        "selfAssessment_laborConditions_genderDiscrimination_receivedResolved_total_resolved_women"
    },
  },
};

export const SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_FULL_TIME = {
  women: {
    fields: [
      "selfAssessment_laborConditions_contract_full_permanent_women",
      "selfAssessment_laborConditions_contract_full_temporary_women",
    ],
    subtotal: "selfAssessment_laborConditions_contract_full_subtotal_women",
  },
  men: {
    fields: [
      "selfAssessment_laborConditions_contract_full_permanent_men",
      "selfAssessment_laborConditions_contract_full_temporary_men",
    ],
    subtotal: "selfAssessment_laborConditions_contract_full_subtotal_men",
  },
};

export const SELF_ASSESSMENT_LC_TYPE_OF_CONTRACT_PART_TIME = {
  women: {
    fields: [
      "selfAssessment_laborConditions_contract_part_permanent_women",
      "selfAssessment_laborConditions_contract_part_temporary_women",
    ],
    subtotal: "selfAssessment_laborConditions_contract_part_subtotal_women",
  },
  men: {
    fields: [
      "selfAssessment_laborConditions_contract_part_permanent_men",
      "selfAssessment_laborConditions_contract_part_temporary_men",
    ],
    subtotal: "selfAssessment_laborConditions_contract_part_subtotal_men",
  },
};
export const SELFASSESMENT_LABORCONDITIONS_TABLE_8 = {
  women: {
    elegible: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_elegible_maternity_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women",
      ],
      total:
        "selfAssessment_laborConditions_leavePolicies_elegible_total_women",
    },
    took: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women",
      ],
      total:
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_total_women",
    },
  },
  men: {
    elegible: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_elegible_paternity_men",
        "selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men",
        "selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men",
      ],
      total: "selfAssessment_laborConditions_leavePolicies_elegible_total_men",
    },
    took: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men",
      ],
      total:
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_total_men",
    },
  },
};

export const SELFASSESMENT_LABORCONDITIONS_TABLE_9 = {
  women: {
    elegible: {
      fields: [
        "selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_women",
        "selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_women",
        "selfAssessment_laborConditions_flexTime_elegible_reductionHours_women",
        "selfAssessment_laborConditions_flexTime_elegible_paidLeave_women",
        "selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_women",
        "selfAssessment_laborConditions_flexTime_elegible_telecommuting_women",
        "selfAssessment_laborConditions_flexTime_elegible_transportationResidence_women",
        "selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_women",
        "selfAssessment_laborConditions_flexTime_elegible_externalChildCare_women",
      ],
      total: "selfAssessment_laborConditions_flexTime_elegible_total_women",
    },
    took: {
      fields: [
        "selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_women",
        "selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_women",
      ],
      total: "selfAssessment_laborConditions_flexTime_tookBenefit_total_women",
    },
  },
  men: {
    elegible: {
      fields: [
        "selfAssessment_laborConditions_flexTime_elegible_flexibitilityArrivalDeparture_men",
        "selfAssessment_laborConditions_flexTime_elegible_NegotiatedShedule_men",
        "selfAssessment_laborConditions_flexTime_elegible_reductionHours_men",
        "selfAssessment_laborConditions_flexTime_elegible_paidLeave_men",
        "selfAssessment_laborConditions_flexTime_elegible_unpaidLeave_men",
        "selfAssessment_laborConditions_flexTime_elegible_telecommuting_men",
        "selfAssessment_laborConditions_flexTime_elegible_transportationResidence_men",
        "selfAssessment_laborConditions_flexTime_elegible_childCareAtCompany_men",
        "selfAssessment_laborConditions_flexTime_elegible_externalChildCare_men",
      ],
      total: "selfAssessment_laborConditions_flexTime_elegible_total_men",
    },
    took: {
      fields: [
        "selfAssessment_laborConditions_flexTime_tookBenefit_flexibitilityArrivalDeparture_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_NegotiatedShedule_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_reductionHours_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_paidLeave_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_unpaidLeave_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_telecommuting_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_transportationResidence_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_childCareAtCompany_men",
        "selfAssessment_laborConditions_flexTime_tookBenefit_externalChildCare_men",
      ],
      total: "selfAssessment_laborConditions_flexTime_tookBenefit_total_men",
    },
  },
};

export const SELF_ASSESSMENT_LC_WAGES = {
  women: {
    fields: [
      "selfAssessment_laborConditions_wages_executiveDirector_women",
      "selfAssessment_laborConditions_wages_management_women",
      "selfAssessment_laborConditions_wages_middleLevel4_women",
      "selfAssessment_laborConditions_wages_middleLevel3_women",
      "selfAssessment_laborConditions_wages_middleLevel2_women",
      "selfAssessment_laborConditions_wages_middleLevel1_women",
      "selfAssessment_laborConditions_wages_technical_women",
      "selfAssessment_laborConditions_wages_administrative_women",
      "selfAssessment_laborConditions_wages_support_women",
      "selfAssessment_laborConditions_wages_operational_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_laborConditions_wages_executiveDirector_men",
      "selfAssessment_laborConditions_wages_management_men",
      "selfAssessment_laborConditions_wages_middleLevel4_men",
      "selfAssessment_laborConditions_wages_middleLevel3_men",
      "selfAssessment_laborConditions_wages_middleLevel2_men",
      "selfAssessment_laborConditions_wages_middleLevel1_men",
      "selfAssessment_laborConditions_wages_technical_men",
      "selfAssessment_laborConditions_wages_administrative_men",
      "selfAssessment_laborConditions_wages_support_men",
      "selfAssessment_laborConditions_wages_operational_men",
    ],
  },
};

export const SELF_ASSESSMENT_LC_WORKING_PARENTS = {
  women: {
    fields: [
      "selfAssessment_laborConditions_workingParents_noWorkingParents_women",
      "selfAssessment_laborConditions_workingParents_noSingleParents_women",
    ],
  },
  men: {
    fields: [
      "selfAssessment_laborConditions_workingParents_noWorkingParents_men",
      "selfAssessment_laborConditions_workingParents_noSingleParents_men",
    ],
  },
};

export const SELF_ASSESSMENT_LC_EXTENDED_LEAVE_POLICIES = {
  women: {
    receive: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_elegible_maternity_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_breastfeeding_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_women",
        "selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_women",
      ],
    },
    take: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_maternity_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_breastfeeding_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_women",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_women",
      ],
    },
    total: "selfAssessment_laborConditions_leavePolicies_elegible_total_women",
  },
  men: {
    receive: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_elegible_paternity_men",
        "selfAssessment_laborConditions_leavePolicies_elegible_reductionWorkingHours_men",
        "selfAssessment_laborConditions_leavePolicies_elegible_permittedLeave_men",
      ],
    },
    take: {
      fields: [
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_paternity_men",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_reductionWorkingHours_men",
        "selfAssessment_laborConditions_leavePolicies_tookBenefit_permittedLeave_men",
      ],
    },
    total: "selfAssessment_laborConditions_leavePolicies_elegible_total_men",
  },
};
